let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jixLg")).then(() => parcelRequire('f16xs'));